import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=d5a50a42&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=d5a50a42&prod&lang=scss&scoped=true"
import style1 from "./AddContact.vue?vue&type=style&index=1&id=d5a50a42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a50a42",
  null
  
)

export default component.exports